import { mapState, mapGetters } from 'vuex';
import { TimePoint } from '../api/grid';
import {
  time2point,
  point2time,
  time2rectangles,
  time2track,
  ProximityTester,
} from '../api/tapi';
import _ from 'lodash-extended';

export default {
  computed: {
    ...mapGetters('timemachine', ['grid']),
    ...mapState('timemachine', {
      axis: (state) => state.viewOffsets.axis,
      rowDuration: (state) => state.timeLayer.rowDuration,
      STATE_INITIALIZING: (state) => state.STATE.INITIALIZING,
      trackLayer: (state) => state.trackLayer,
      CONST: (state) => state.CONST,
      pxAudioTopOffset: (state) => state.cssVariables.pxAudioTopOffset,
      pxAudioTrackH: (state) => state.cssVariables.pxAudioTrackH,
    }),

    gridEstablished() {
      return this.grid.length > 0 && !this.STATE_INITIALIZING && !!this.axis;
    },
  },

  methods: {
    $_toInternal(point) {
      this.axis.toInternal(point);
      return point;
    },

    $_toExternal(point) {
      this.axis.toExternal(point);
      return point;
    },

    /**
     * @param e {MouseEvent}
     * @param [timePoint] {TimePoint}
     * @param [shiftX] {number}
     * @param [shiftY] {number}
     * @returns {TimePoint}
     */
    $_mouse2point(e, timePoint, shiftX = 0, shiftY = 0) {
      if (timePoint) {
        timePoint.set(e.clientX, e.clientY);
      } else {
        timePoint = new TimePoint(e.clientX, e.clientY, null);
      }
      timePoint.shift(shiftX, shiftY);
      this.$_toInternal(timePoint);
      this.$_point2time(timePoint);
      return timePoint;
    },

    /**
     * @param time {number}
     * @param pushOverEdge {boolean}
     * @param [timePoint] {TimePoint}
     * @returns {TimePoint|null}
     */
    $_time2point(time, pushOverEdge, timePoint) {
      return time2point(
        this.grid,
        time,
        pushOverEdge,
        this.rowDuration,
        timePoint
      );
    },

    /**
     * @param timePoint {TimePoint}
     * @returns {number|null}
     */
    $_point2time(timePoint) {
      return point2time(this.grid, timePoint);
    },

    $_time2rectangles(startTime, endTime, excludeEmpty) {
      return time2rectangles(
        this.grid,
        startTime,
        endTime,
        this.rowDuration,
        excludeEmpty
      );
    },

    $_time2visualTrack(time) {
      return time2track(this.trackLayer.visual, time);
    },

    $_time2audioTrack(time) {
      return time2track(this.trackLayer.audio, time);
    },

    $_createProximityTester(aTime, distance) {
      distance = distance ?? this.CONST.AUTOSNAP_PROXIMITY.DEFAULT;
      const continuum = this.grid[0].continuum;
      return new ProximityTester(continuum, aTime, distance);
    },

    $_isInRangeOfAudioTrack(mouseY, range) {
      let rv = false;

      for (const rect of this.grid) {
        const top = rect.p1.y + this.pxAudioTopOffset;
        const bottom = top + this.pxAudioTrackH;
        rv = _.between(top - range, mouseY, bottom + range);
        if (rv) {
          break;
        }
      }

      return rv;
    },
  },
};
